module.exports = __webpack_public_path__ + "img/ume_logo.926c914c.png";